import { signOut } from "firebase/auth";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: false,
    userdetails: {},
  }),
  actions: {
    resetStore() {
      this.$reset();
      localStorage.removeItem("user");
    },
    SetUserDetails(user) {
      if (user) {
        this.userdetails = user;
        this.isAuthenticated = true;
        localStorage.setItem("user", JSON.stringify(user));
      }
    },
    async getAuthState() {
      if (this.isAuthenticated) {
        //console.log("🔑 Authenticated Auth Store");
        return this.isAuthenticated;
      }

      const storedUser = localStorage.getItem("user");

      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          this.SetUserDetails(user);

          if (!user.emailVerified) {
            console.log("🔒 Email not verified", user.emailVerified);
            return false;
          }

          console.log(
            "User Exists:",
            !!user,
            "User is authenticated:",
            this.isAuthenticated
          );
          return this.isAuthenticated;
        } catch (error) {
          console.error("Failed to parse user JSON:", error);
          return false;
        }
      }

      console.log("🔒 Login Required", this.isAuthenticated);
      return false;
    },
    async signOut() {
      const auth = useFirebaseAuth();
      //  console.log("signing out", auth);
      await signOut(auth);
      this.isAuthenticated = false;
      this.userdetails = {};
      localStorage.removeItem("user");
    },
  },
  getters: {
    getuid() {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        return user.uid;
      }
      return this.userdetails.uid;
    },
    email() {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        return user.email;
      }
      return this.userdetails.email;
    },
    emailVerified() {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        return user.emailVerified;
      }
      return this.userdetails.emailVerified;
    },
  },
});
